import React, { useState, useRef } from 'react';
import { login, register, logout, changeUsername, changeAvatar } from '../services/api';

function ProfilePanel({ user, onLogout, onUpdateUser }) {
  const [isLogin, setIsLogin] = useState(true);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [editingUsername, setEditingUsername] = useState(false);
  const [newUsername, setNewUsername] = useState('');
  const [editingAvatar, setEditingAvatar] = useState(false);
  const [avatarPreview, setAvatarPreview] = useState('');
  const fileInputRef = useRef(null);

  const avatars = [
    '👤', '😊', '😎', '🤩', '😺', '🦊', '🐱', '🐶',
    '🐼', '🐨', '🦁', '🐯', '🐮', '🐷', '🐸', '🐵',
    '🦄', '🐲', '🐉', '🦋', '🌸', '🌺', '🌻', '🌹',
    '🍕', '🍔', '🌮', '🍣', '🎮', '🎸', '🎨', '🚀'
  ];

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (isLogin) {
        const res = await login(username, password);
        if (res.data.success) {
          onLogout();
          setUsername('');
          setPassword('');
        }
      } else {
        if (password !== confirmPassword) {
          alert('❌ Пароли не совпадают');
          return;
        }
        if (password.length < 4) {
          alert('❌ Пароль должен быть не менее 4 символов');
          return;
        }
        await register(username, password);
        alert('✅ Регистрация успешна! Теперь войдите.');
        setIsLogin(true);
        setUsername('');
        setPassword('');
        setConfirmPassword('');
      }
    } catch (err) {
      alert('❌ Ошибка: ' + (err.response?.data?.error || 'Неизвестная ошибка'));
    }
  };

  const handleChangeUsername = async () => {
    if (!newUsername.trim() || newUsername.trim() === user?.username) {
      setEditingUsername(false);
      return;
    }
    if (newUsername.trim().length < 3) {
      alert('❌ Юзернейм должен быть не менее 3 символов');
      return;
    }
    try {
      await changeUsername(newUsername.trim());
      alert('✅ Юзернейм изменен!');
      setEditingUsername(false);
      if (onUpdateUser) {
        await onUpdateUser();
      }
    } catch (err) {
      alert('❌ Ошибка: ' + (err.response?.data?.error || 'Неизвестная ошибка'));
    }
  };

  const handleChangeAvatar = async (avatar) => {
    try {
      const result = await changeAvatar(avatar);
      alert('✅ Аватарка изменена!');
      setEditingAvatar(false);
      setAvatarPreview('');
      if (onUpdateUser) {
        await onUpdateUser();
      }
    } catch (err) {
      alert('❌ Ошибка: ' + (err.response?.data?.error || 'Неизвестная ошибка'));
    }
  };

  const handleFileUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    if (file.size > 500 * 1024) {
      alert('❌ Файл слишком большой! Максимум 500KB');
      event.target.value = '';
      return;
    }

    if (!file.type.startsWith('image/')) {
      alert('❌ Пожалуйста, выберите изображение');
      event.target.value = '';
      return;
    }

    const reader = new FileReader();
    reader.onload = async (e) => {
      try {
        const img = new Image();
        img.onload = async () => {
          const canvas = document.createElement('canvas');
          const MAX_SIZE = 200;
          
          let width = img.width;
          let height = img.height;
          
          if (width > height) {
            if (width > MAX_SIZE) {
              height = height * (MAX_SIZE / width);
              width = MAX_SIZE;
            }
          } else {
            if (height > MAX_SIZE) {
              width = width * (MAX_SIZE / height);
              height = MAX_SIZE;
            }
          }
          
          canvas.width = width;
          canvas.height = height;
          const ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0, width, height);
          
          const compressedBase64 = canvas.toDataURL('image/jpeg', 0.7);
          
          try {
            const result = await changeAvatar(compressedBase64);
            alert('✅ Аватарка обновлена!');
            setEditingAvatar(false);
            setAvatarPreview('');
            if (onUpdateUser) {
              await onUpdateUser();
            }
          } catch (err) {
            alert('❌ Ошибка: ' + (err.response?.data?.error || 'Неизвестная ошибка'));
          }
        };
        img.src = e.target.result;
      } catch (err) {
        alert('❌ Ошибка обработки изображения');
      }
    };
    reader.readAsDataURL(file);
    event.target.value = '';
  };

  const handleAvatarClick = () => {
    if (user) {
      setEditingAvatar(true);
    }
  };

  if (!user) {
    return (
      <div className="profile-panel">
        <div className="avatar-large">👤</div>
        <div className="username">Гость</div>
        <div className="user-status" style={{ color: '#666' }}>
          Не авторизован
        </div>

        <div className="auth-section">
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <input
                type="text"
                placeholder="Юзернейм"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
              />
            </div>
            <div className="form-group">
              <input
                type="password"
                placeholder="Пароль"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>
            {!isLogin && (
              <div className="form-group">
                <input
                  type="password"
                  placeholder="Подтвердите пароль"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  required
                />
              </div>
            )}
            <button type="submit" className="btn btn-primary">
              {isLogin ? '🔑 Войти' : '📝 Зарегистрироваться'}
            </button>
            <div className="switch-auth" onClick={() => setIsLogin(!isLogin)}>
              {isLogin ? 'Нет аккаунта? Зарегистрироваться' : 'Уже есть аккаунт? Войти'}
            </div>
          </form>
        </div>
      </div>
    );
  }

  return (
    <div className="profile-panel">
      <div 
        className="avatar-large" 
        onClick={handleAvatarClick}
        onMouseEnter={(e) => {
          e.target.style.transform = 'scale(1.05)';
          e.target.style.boxShadow = '0 0 30px rgba(108, 92, 231, 0.3)';
        }}
        onMouseLeave={(e) => {
          e.target.style.transform = 'scale(1)';
          e.target.style.boxShadow = 'none';
        }}
      >
        {avatarPreview || (user?.avatar && user.avatar.startsWith('data:image') ? (
          <img 
            src={user.avatar} 
            alt={user.username}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover'
            }}
          />
        ) : (user?.avatar || '👤'))}
        <div style={{
          position: 'absolute',
          bottom: '5px',
          right: '5px',
          background: '#6c5ce7',
          borderRadius: '50%',
          padding: '4px',
          fontSize: '12px',
          color: '#fff'
        }}>
          ✏️
        </div>
      </div>

      {editingAvatar && (
        <div style={{
          width: '100%',
          background: '#0a0a1a',
          borderRadius: '12px',
          padding: '10px',
          margin: '10px 0',
          maxHeight: '250px',
          overflowY: 'auto'
        }}>
          <div style={{ 
            display: 'flex', 
            flexWrap: 'wrap', 
            gap: '8px',
            justifyContent: 'center',
            marginBottom: '10px'
          }}>
            {avatars.map(avatar => (
              <button
                key={avatar}
                onClick={() => handleChangeAvatar(avatar)}
                style={{
                  background: user.avatar === avatar ? '#6c5ce7' : '#1a1a2e',
                  border: '2px solid ' + (user.avatar === avatar ? '#6c5ce7' : 'transparent'),
                  borderRadius: '50%',
                  width: '40px',
                  height: '40px',
                  fontSize: '20px',
                  cursor: 'pointer',
                  transition: 'all 0.3s',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
                onMouseEnter={(e) => {
                  e.target.style.transform = 'scale(1.1)';
                  e.target.style.borderColor = '#6c5ce7';
                }}
                onMouseLeave={(e) => {
                  e.target.style.transform = 'scale(1)';
                  if (user.avatar !== avatar) {
                    e.target.style.borderColor = 'transparent';
                  }
                }}
              >
                {avatar}
              </button>
            ))}
          </div>

          <div style={{ 
            borderTop: '1px solid #2a2a4a',
            paddingTop: '10px',
            marginTop: '5px'
          }}>
            <p style={{ 
              fontSize: '12px', 
              color: '#888', 
              textAlign: 'center',
              marginBottom: '8px'
            }}>
              📸 Или загрузите свое фото:
            </p>
            <input
              ref={fileInputRef}
              type="file"
              accept="image/*"
              onChange={handleFileUpload}
              style={{
                width: '100%',
                padding: '8px',
                background: '#1a1a2e',
                border: '1px solid #2a2a4a',
                borderRadius: '8px',
                color: '#e0e0e0',
                fontSize: '12px',
                cursor: 'pointer'
              }}
            />
          </div>

          <button
            onClick={() => {
              setEditingAvatar(false);
              setAvatarPreview('');
            }}
            style={{
              width: '100%',
              marginTop: '10px',
              padding: '6px',
              background: '#2a2a4a',
              border: 'none',
              borderRadius: '6px',
              color: '#888',
              cursor: 'pointer',
              fontSize: '12px'
            }}
          >
            ✖ Закрыть
          </button>
        </div>
      )}

      <div className="username" style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '5px' }}>
        {editingUsername ? (
          <input 
            value={newUsername}
            onChange={(e) => setNewUsername(e.target.value)}
            onBlur={handleChangeUsername}
            onKeyPress={(e) => {
              if (e.key === 'Enter') handleChangeUsername();
              if (e.key === 'Escape') {
                setEditingUsername(false);
                setNewUsername(user.username);
              }
            }}
            autoFocus
            style={{
              background: '#0a0a1a',
              border: '2px solid #6c5ce7',
              borderRadius: '8px',
              padding: '6px 12px',
              color: '#e0e0e0',
              fontSize: '18px',
              width: '100%',
              outline: 'none'
            }}
          />
        ) : (
          <>
            <span>{user.username}</span>
            <button 
              onClick={() => {
                setEditingUsername(true);
                setNewUsername(user.username);
              }}
              style={{
                background: 'none',
                border: 'none',
                color: '#6c5ce7',
                cursor: 'pointer',
                fontSize: '14px',
                padding: '4px 8px',
                borderRadius: '6px',
                transition: 'all 0.3s'
              }}
              onMouseEnter={(e) => {
                e.target.style.background = 'rgba(108, 92, 231, 0.2)';
              }}
              onMouseLeave={(e) => {
                e.target.style.background = 'transparent';
              }}
              title="Изменить юзернейм"
            >
              ✏️
            </button>
          </>
        )}
      </div>

      <div className="user-status" style={{ color: user.isAdmin ? '#e74c3c' : '#00b894' }}>
        {user.isAdmin ? '🛡️ Администратор' : '🟢 Онлайн'}
      </div>

      <div className="user-info">
        <div className="info-item">
          <span className="label">👤 Юзернейм</span>
          <span className="value">{user.username}</span>
        </div>
        <div className="info-item">
          <span className="label">📅 Регистрация</span>
          <span className="value">{new Date(user.createdAt || Date.now()).toLocaleDateString('ru-RU')}</span>
        </div>
        {user.isAdmin && (
          <div className="info-item">
            <span className="label">🛡️ Статус</span>
            <span className="value" style={{ color: '#e74c3c', fontWeight: 'bold' }}>
              Администратор
            </span>
          </div>
        )}
      </div>

      <button 
        className="btn btn-danger" 
        onClick={async () => {
            if (window.confirm('🚪 Выйти из аккаунта?')) {
            await logout();
            onLogout();
            }
        }}
        >
        🚪 Выйти
        </button>
    </div>
  );
}

export default ProfilePanel;